import React, { useState, useEffect } from 'react'
import { isMobile, isTablet } from "react-device-detect"
import Toggle from './Toggle'
import { css } from 'emotion'

const OffersDisplay = (props) => {

    // const renderContent = (content) => {
    //     return { __html: content };
    // }

    const [offerTile1, setOfferTile1] = useState('')
    const [offerTile2, setOfferTile2] = useState('')

    useEffect(() => {
        if (props.offers.EirOfferToggleMobile[0] && (props.offers.EirOfferToggleMobile[0].EirOfferTile.length > 2) && (isMobile && !isTablet)) {
            let tile = props.offers.EirOfferToggleMobile[0].EirOfferTile;
            tile.splice(-1, 1)
            setOfferTile1(tile)
        } else if (props.offers.EirOfferToggleMobile[0] && isMobile) {
            setOfferTile1(props.offers.EirOfferToggleMobile[0].EirOfferTile)
        } else {
            setOfferTile1(props.offers.EirOfferToggle[0].EirOfferTile)
        }

        if (props.offers.EirOfferToggleMobile[1] && (props.offers.EirOfferToggleMobile[1].EirOfferTile.length > 2) && (isMobile && !isTablet)) {
            let tile = props.offers.EirOfferToggleMobile[1].EirOfferTile;
            tile.splice(-1, 1)
            setOfferTile2(tile)
        } else if (props.offers.EirOfferToggleMobile[1] && isMobile) {
            setOfferTile2(props.offers.EirOfferToggleMobile[1].EirOfferTile)
        } else {
            setOfferTile2(props.offers.EirOfferToggle[1].EirOfferTile)
        }
    }, []);


    const getBackgroundImage = () => {
        if (isMobile && !isTablet) {
            return props.offers.backgroundImageMobile.path
        }
        return props.offers.backgroundImage.path
    }

    if (offerTile1 !== '' && offerTile2 !== '') {
        return (
            <div className='eir-offers-main'>
                <div className={css`background-color: ${(isMobile && !isTablet) ? props.offers.backgroundColorMobile : props.offers.backgroundColor};` + ' first-child pt-4 pb-5'} style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}>
                    {/* <div className='homepage-modules-title' dangerouslySetInnerHTML={renderContent(props.offers.title)}></div> */}
                    <Toggle toggle={props.offers} offerTile1={offerTile1} offerTile2={offerTile2} />
                </div>
            </div>
        )
    } else {
        return <div></div>
    }
}

export default OffersDisplay